// Node, IE, and a bunch of mobile don't support Object.values, so this is a very simple temporary solution:
// (Note: this won't strip out functions, so it should only be used on very simple objects.)
const objectValues = object => Object.keys(object).map(key => object[key])

export {
  objectValues
}
